import React, { ReactNode, createContext, useCallback, useEffect, useState } from 'react';
import { MsalAuthenticationTemplate, MsalProvider, useAccount, useMsal } from '@azure/msal-react';
import { AuthenticationResult, Configuration, InteractionType, PublicClientApplication, RedirectRequest } from '@azure/msal-browser';
import { getB2cConfigExperience } from "./msalConfig";
import Storage from './storage';
import axios from 'axios';
import Constants from './constants';
import Utils from './utils';
//import Rest from '../../general/rest';

const scopes = ["openid"]
const authRequest = {
  scopes: scopes
}

export const GetTokenContext = createContext(async () => undefined)

/**
 * A component inside which nothing will render until a valid AD B2C authentication exists, and which redirects
 * the user to the authentication workflow if they are not authenticated.
 */
const Authwall = props => {
  let [pca, setPca] = useState(undefined)

  const queryParams = new URLSearchParams(window.location.search);
  const authExperience = queryParams.get("authExperience")??"default";

  //Fetch the AD B2C configuration details and create the public client application object
  useEffect(() => {
    const getConfig = async () => {
      var b2cConfig = getB2cConfigExperience(authExperience)

      return b2cConfig
    }
    const fetchConfig = async () => {
      const config = await getConfig()
      if (config) {
        const newPca = new PublicClientApplication(config)
        setPca(newPca)
      }
    }
    fetchConfig()
  }, [])

  return pca === undefined ? (
    <></>
  ) : (
    <MsalProvider instance={pca}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={authRequest}
      >
        <MsalContainer>{props.children}</MsalContainer>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  )
}

/**
 * Inner component for authwall, enabling the use of the useMsal hook.
 */
const MsalContainer = props => {
  const { instance, accounts } = useMsal()
  const account = useAccount(accounts[0] || {})

  //The token fetch method, which will go into a context allowing any part of the app to use
  //the jwt token
  const fetchToken = useCallback(async () => {
    let ret = undefined
    if (account) {
      const token = await instance.acquireTokenSilent({
        scopes: scopes,
        account: account
      })
      if (token) {
        ret = token
      }
    }
    return ret
  }, [instance, account])

  //Initialize the rest client with the jwt token so that the token is automatically passed to
  //all API calls
  useEffect(() => {
    const asyncPortionOfUseEffect = async () => {
      const b2cToken = (await fetchToken())?.idToken

      try {
        const url = `${process.env.REACT_APP_ADMIN_API}/legacyTokenUsingB2C`
        const config = { headers: { "Content-Type": "application/json" } }
        const res = await axios.post(url, '"' + b2cToken + '"', config)
        const jwt = res.data
        const jwtData = Utils.decodeJwt(jwt)
        console.log(
          `useEffect [account]: processing JWT  ${JSON.stringify(jwtData)} `
        )
        if (jwtData.OTP && jwtData.OTP != 0) {
          Storage.setItem("key", jwtData.OTP)
        } else {
          console.log(`else`)
          let user = Storage.getItem(Constants.currUserKey)
          Storage.setItem(Constants.userRole, jwtData.role)
          let familyName = jwtData[Constants.familyName]
          Storage.setItem(Constants.familyName, familyName)
          if (!user) {
            user = {
              jwt: ""
            }
          }
          user.jwt = jwt
          Storage.setItem(Constants.currUserKey, user)
          //setstate({...state, user});
          console.log(`useEffect [account]: user ${JSON.stringify(user)} `)
        }
      } catch (error) {
        console.log('Current Path = ' + window.location.pathname);
        if (window.location.pathname !== '/fourzeroone') {
          window.location = '/fourzeroone';
        }
      }

    }

    asyncPortionOfUseEffect()
  }, [fetchToken])

  return (
    <GetTokenContext.Provider value={fetchToken}>
      {props.children}
    </GetTokenContext.Provider>
  )
}

export default Authwall